<template>
  <div class="view news">
    <loader v-if="loading" />
    <template v-else-if="detail">
      <div class="view-visual">
        <img
          v-if="detail && detail.picture"
          :src="detail.picture.src"
          :srcset="`${detail.picture.src2x} 2x`"
          :alt="detail.title"
        />
        <img
          v-else
          src="@/assets/images/event-default.jpg"
          :alt="news.title"
        />
        <!-- <router-link to="/" class="view-backlink"> -->
        <button @click.prevent="onBack" class="view-backlink">
          <sprite
            :type="'chevron-left'"
            :width="5"
            :height="8"
          />
          Retour
        </button>
      </div>

      <div class="view-content">
        <div class="container">
          <div class="view-content-wrapper">
            <template v-if="detail">
              <h1
                class="view-content-title h1"
                v-html="detail.title"
              />
              <span class="view-content-date">Publié le {{ detail.date }}</span>

              <div
                ref="newsContent"
                v-html="content"
                class="view-content-text typeset"
              />

              <button
                class="view-content-share"
                @click="onShare"
              >
                Je partage
                <sprite
                  :type="'share'"
                  :width="16"
                  :height="16"
                />
              </button>
            </template>
          </div>

          <h2 class="h1">Autres actualités</h2>
          <news-slider
            :loading="loadingNews"
            :slides="news"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import NewsSlider from '@/components/partials/NewsSlider.vue';
import Loader from '@/components/components/Loader.vue';
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Loader,
    Sprite,
    NewsSlider
  },
  computed: {
    detail() {
      return this.$store.state.news.item;
    },
    content() {
      return this.$store.state.news.item && this.$store.state.news.item.content ? this.$store.state.news.item.content : null;
    },
    news() {
      return this.$store.state.news.items.filter(n => n.id !== this.$store.state.news.item.id);
    },
    loading() {
      return this.$store.state.news.requestsDetail !== 0;
    },
    loadingNews() {
      return this.$store.state.news.requests !== 0;
    }
  },
  data() {
    return {
      links: null
    };
  },
  watch: {
    content(val) {
      if (val) {
        this.$nextTick(() => {
          this.bindLinks();
        });
      }
    },
    $route(newRoute) {
      const { slug } = newRoute.params;
      this.$store.dispatch('news/getDetail', slug);
    },
  },
  beforeMount() {
    const { slug } = this.$route.params;
    if (!this.$store.state.news.item || this.$store.state.news.item.slug !== slug) {
      this.$store.dispatch('news/getDetail', slug);
    }

    if (this.$store.state.news.items.length === 0) {
      this.$store.dispatch('news/get');
    }
  },
  methods: {
    bindLinks() {
      this.links = [...this.$refs.newsContent.querySelectorAll('a')];

      for (let i = 0; i < this.links.length; i++) {
        const link = this.links[i];
        link.setAttribute('target', '_blank');
      }
    },
    onBack() {
      this.$router.push({ name: 'Home' });
    },
    onShare() {
      if (!navigator.share) {
        return;
      }

      navigator.share({
        title: document.title,
        text: this.event.title,
        url: window.location.href
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  position: relative;
  padding-top: 104px;

  // Visual
  // -----------------------------------------------------------------------------
  &-visual {
    @include aspect-ratio(375, 218);
    position: relative;
    background-color: $grey;

    img {
      @include position(absolute, 0 null null 0);
      @include size(100%);
      object-fit: cover;
    }
  }

  &-backlink {
    @include position(absolute, 26px null null 30px);
    @include font('secondary', 'regular');
    color: $primary;
    font-size: rem(16px);
    line-height: 1;

    .svg {
      @include margin(-2px 4px null null);
      vertical-align: middle;
      fill: $primary;
    }
  }

  // Content
  // -----------------------------------------------------------------------------
  &-content {
    &:last-child {
      @include padding(null null 40px);
    }

    &-wrapper {
      @include padding(32px 16px 21px 16px);
      @include margin(-34px null 40px);
      display: flex;
      position: relative;
      z-index: 1;
      flex-direction: column;
      align-items: flex-start;
      background-color: $black-light;
    }

    .headline {
      color: rgba($white, .3);
    }

    &-title {
      @include margin(5px null null);
    }

    &-date {
      @include margin(12px null null);
      color: $primary;
      font-size: rem(18px);
      line-height: 1;

      .svg {
        @include margin(-2px null null);
        display: inline-block;
        vertical-align: middle;
        fill: $primary;
      }
    }

    &-location {
      @include margin(12px null null);
      font-size: rem(18px);
      line-height: 1;
    }

    &-text {
      @include margin(40px null null);
    }

    &-share {
      @include margin(12px null null);
      @include padding(15px 24px);
      @include font('secondary', 'regular');
      display: flex;
      align-items: center;
      align-self: center;
      color: $white;
      font-size: rem(14px);
      line-height: 1;

      .svg {
        @include margin(-1px null null 8px);
        fill: $white;
      }
    }

    .slider {
      @include margin(20px null null);
    }
  }

  // Loader
  // -----------------------------------------------------------------------------
  .loader {
    @include position(absolute, 50% null null 50%);
    transform: translate(-50%, -50%);
  }
}
</style>

<style lang="scss">
.news {
  .view-content {
    .view-content-text {
      p,
      span {
        color: $white !important;
        font-size: rem(14px) !important;
        line-height: 1.5 !important;
      }

      img,
      video,
      iframe {
        width: 100% !important;
        height: auto !important;
        max-width: 100%;
      }
    }
  }

  &.has-sticky {
    + .footer {
      @include margin(null null 75px);
    }
  }
}
</style>
